import { render, staticRenderFns } from "./CourseDirectionPay.vue?vue&type=template&id=10ba4214&scoped=true&"
import script from "./CourseDirectionPay.vue?vue&type=script&lang=js&"
export * from "./CourseDirectionPay.vue?vue&type=script&lang=js&"
import style0 from "./CourseDirectionPay.vue?vue&type=style&index=0&id=10ba4214&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ba4214",
  null
  
)

export default component.exports